import {
  CalcType,
  CalcTypeStd,
  ConfigurationCountry,
  ConfigurationId,
  ToggleProps,
} from '@types';

export type CalcTypeConfig = ToggleProps | CalcTypeStd;

const calcTypeConfiguration: Record<ConfigurationId, CalcTypeConfig> = {
  [ConfigurationId.CEF]: {
    labelKey: CalcType.NAV_MARKET_PRICE,
    options: [
      {
        label: 'products.nav',
        value: CalcTypeStd.NAV,
      },
      {
        label: 'products.market-price',
        value: CalcTypeStd.MARKET_PRICE,
      },
    ],
    selected: CalcTypeStd.NAV,
    type: 'toggle',
  },
  [ConfigurationId.SMA]: {
    labelKey: CalcType.PURE_GROSS_NET,
    options: [
      {
        label: 'products.net',
        value: CalcTypeStd.NET,
      },
      {
        label: 'products.gross',
        value: CalcTypeStd.GROSS,
      },
    ],
    selected: CalcTypeStd.GROSS,
    applicableValues: {
      GROSS: [CalcTypeStd.PUREGROSS, CalcTypeStd.GROSS],
    },
    type: 'toggle',
  },
  [ConfigurationId.MF]: {
    labelKey: CalcType.SALES_CHARGES,
    options: [
      {
        label: 'products.off',
        value: CalcTypeStd.NET,
      },
      {
        label: 'products.on',
        value: CalcTypeStd.POP,
      },
    ],
    selected: CalcTypeStd.NET,
    type: 'switch',
  },
  [ConfigurationId.MMF]: {
    labelKey: CalcType.SALES_CHARGES,
    options: [
      {
        label: 'products.off',
        value: CalcTypeStd.NET,
      },
      {
        label: 'products.on',
        value: CalcTypeStd.POP,
      },
    ],
    selected: CalcTypeStd.NET,
    type: 'switch',
  },
  [ConfigurationId.ETF]: {
    labelKey: CalcType.NAV_MARKET_PRICE,
    options: [
      {
        label: 'products.nav',
        value: CalcTypeStd.NAV,
      },
      {
        label: 'products.market-price',
        value: CalcTypeStd.MARKET_PRICE,
      },
    ],
    selected: CalcTypeStd.NAV,
    type: 'toggle',
  },
  // NGC-7688: Remove the Switch for Institutional Mutual Funds - Compliance comment
  [ConfigurationId.TIF]: CalcTypeStd.NET,
  [ConfigurationId.GW]: CalcTypeStd.NET,
  [ConfigurationId.US]: CalcTypeStd.NET,
  [ConfigurationId.VIP]: CalcTypeStd.NET,
  [ConfigurationId._529]: {
    labelKey: CalcType.SALES_CHARGES,
    options: [
      {
        label: 'products.off',
        value: CalcTypeStd.NET,
      },
      {
        label: 'products.on',
        value: CalcTypeStd.POP,
      },
    ],
    selected: CalcTypeStd.NET,
    type: 'switch',
  },
  [ConfigurationId.IF]: {
    labelKey: CalcType.SALES_CHARGES,
    options: [
      {
        label: 'products.off',
        value: CalcTypeStd.NET,
      },
      {
        label: 'products.on',
        value: CalcTypeStd.POP,
      },
    ],
    selected: CalcTypeStd.NET,
    type: 'switch',
  },
  [ConfigurationId.TOF]: {
    labelKey: CalcType.SALES_CHARGES,
    options: [
      {
        label: 'products.off',
        value: CalcTypeStd.NAV,
      },
      {
        label: 'products.on',
        value: CalcTypeStd.POP,
      },
    ],
    selected: CalcTypeStd.NAV,
    type: 'switch',
  },
  [ConfigurationId.INDICES]: CalcTypeStd.NET,
  [ConfigurationId.SEGREGATED]: CalcTypeStd.NET,
  [ConfigurationId.UAFF]: CalcTypeStd.NET,
  [ConfigurationId.CIT]: CalcTypeStd.NET,
};

export const getCalcTypeConfig = (
  configurationId: ConfigurationId,
  country: ConfigurationCountry
): CalcTypeConfig => {
  if (country === 'SG') {
    if (configurationId === ConfigurationId.MF) {
      // NGC-7670: NextGen Singapore - Add Sales Charge Toggle for Mutual Funds
      return {
        labelKey: CalcType.SALES_CHARGES,
        options: [
          {
            label: 'products.off',
            value: CalcTypeStd.NET,
          },
          {
            label: 'products.on',
            value: CalcTypeStd.AACR,
          },
        ],
        selected: CalcTypeStd.NET,
        type: 'switch',
      };
    } else if (configurationId === ConfigurationId.MMF) {
      return CalcTypeStd.NET;
    }
  }
  // for other countries return from main config
  return calcTypeConfiguration[configurationId];
};
